// What "your turn" hands to the phone's drawer (a phone-only piece, drawn by
// name through `PhoneSlot`). The panel keeps what it shows (the tag row, the
// item and its answer); the drawer only holds them.
import type { ReactNode, RefObject } from "react";

/** The phone kit's slot that draws the drawer. */
export const TURN_DRAWER_SLOT = "agents.turnDrawer";

export interface TurnDrawerProps {
  /** Up (it stays mounted while down: what is being written stays). */
  open: boolean;
  /** Its name for screen readers. */
  label: string;
  /** Where it lies over (the chat's column, under the header). */
  host: HTMLElement;
  /** Closes it (the grabber or the tag row swiped down, Escape, back, the scrim). */
  onClose(): void;
  /** The tag row, under the grabber (swiping it down closes too). */
  head: ReactNode;
  /** What is read and answered, in one scroll. */
  children: ReactNode;
  /** The row at its bottom where the buttons that answer go (`TurnFoot`). */
  onFoot(el: HTMLElement | null): void;
  /** The item shown: when it changes, the scroll starts over at its top. */
  itemKey: string;
  /** What gets the focus back when it closes with the focus inside (the folded line). */
  opener: RefObject<HTMLElement | null>;
  /**
   * Raises it: called when the person comes back (the browser's back) to the
   * entry it had while up, from a page a link inside it opened.
   */
  onOpen?(): void;
}
